import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { styled } from '@uhg-abyss/web/tools/styled';
import { useUser } from '@sde/widgets-core/src/redux/resources/user';
import { Box } from '@uhg-abyss/web/ui/Box';
import { validatePermissions } from '@sde/widgets-core/src/redux/resources/user/helpers';
import { PageLayout } from '../PageLayout';

const MessageBox = styled(Box, {
  margin: '40px 0',
});

export const ValidateApp = ({ children, app }) => {
  const { user } = useUser.state();
  const { validateUser } = useUser.actions();

  useEffect(() => {
    validateUser();
  }, []);

  return (
    <Choose>
      <When condition={!user.uuid}>{null}</When>
      <When condition={validatePermissions(user, app)}>{children}</When>
      <When condition={user.uuid}>
        <PageLayout>
          <MessageBox>
            You do not have permission to access this application.
          </MessageBox>
        </PageLayout>
      </When>
    </Choose>
  );
};

ValidateApp.propTypes = {
  children: PropTypes.node.isRequired,
  app: PropTypes.string.isRequired,
};
